import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// HighCharts
import Message from '../../../components/message';
import Highcharts from 'highcharts';
import CommonHighcharts from '../../../components/common/common-highcharts';

// Helper
import { assignColour } from '../../../helpers/colours';
import { sortChartData } from './helpers/chart-helper';
import { calculateProportion, getTotals } from '../../../components/tables/helpers/table-helper';
import { useSelector } from 'react-redux';

const StyledPieChart = styled.div`
    min-height: 310px;
    min-width: 0px;
    postion: relative;
    opacity: ${props => props.isLoading && 0.5};
    transition: ${props => props.isLoading && props.theme.transition};
    flex-grow: 1;
    flex-basis: 20em;
`;

const PieChart = ({
    config,
    data,
    dimensions,
    metrics,
    loading,
    selectedMetric,
    selectedRows,
    messageTitle = 'No data.',
    messageCopy = '',
    messageType = 'info',
    noData,
}) => {
    const columns = [...dimensions, ...metrics];
    const currencySymbol = useSelector(state => state.currency.symbol);
    const [sortedData, setSortedData] = useState([]);
    const [isPercentage, setIsPercentage] = useState(true);
    const [hasNoData, setHasNoData] = useState(noData);

    useEffect(() => {
        if (config.chart) {
            getPieChartData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, selectedMetric, selectedRows]);

    const getPieChartData = () => {
        let pieData = [];

        if (selectedRows.length === 0) {
            columns.forEach(column => {
                if (data.objects !== undefined) {
                    data.objects.map(row => {
                        if (selectedMetric[0].displayProportion) {
                            if (column.children && row[column.rawName] !== undefined) {
                                let pieValue = parseFloat(row[selectedMetric[0].rawName].proportion);

                                if (!loading) {
                                    if (Number.isNaN(pieValue)) {
                                        setIsPercentage(false);
                                    } else {
                                        setIsPercentage(true);
                                    }
                                }

                                pieData.push({
                                    name: row[column.rawName].value,
                                    y: pieValue,
                                    color: assignColour(row, dimensions, selectedRows)._originalInput,
                                });
                            }
                        } else {
                            setIsPercentage(false);
                        }
                        return pieData;
                    });
                }
                return pieData;
            });
        }

        if (selectedRows.length > 0) {
            let newData = { objects: [] };
            let newProportionsData = [];
            let totals = [];
            let newTotal = 0;

            selectedRows.forEach(row => {
                totals = getTotals(row.dataMeta, dimensions, selectedMetric);
                newTotal = newTotal + row.data[selectedMetric[0].rawName].raw_value;
                totals[1].displayData = currencySymbol + newTotal;
                row.data.colour = row.colour._originalInput;
                newData.objects.push(row.data);
            });

            if (selectedMetric[0].displayProportion) {
                newProportionsData = calculateProportion(selectedMetric[0], totals, newData, currencySymbol);

                newProportionsData.objects.forEach(row => {
                    let pieValue = parseFloat(row[selectedMetric[0].rawName].proportion);
                    if (!loading) {
                        if (Number.isNaN(pieValue)) {
                            setIsPercentage(false);
                        } else {
                            setIsPercentage(true);
                        }
                    }

                    pieData.push({
                        name: row[dimensions[0].rawName].value,
                        y: pieValue,
                        color: row.colour,
                    });
                });
            } else {
                setIsPercentage(false);
            }
        }

        let dataSorted = pieData.sort(sortChartData);
        // return top 10 from data
        setSortedData(dataSorted.slice(0, 10));

        if (!loading) {
            setHasNoData(noData);
        }
    };

    if (!loading) {
        config.chart.options.series[0].data = sortedData;
    }

    if (hasNoData) {
        return (
            <StyledPieChart isLoading={loading}>
                <Message title={messageTitle} copy={messageCopy} type={messageType} />
            </StyledPieChart>
        );
    }

    if (!isPercentage) {
        return (
            <StyledPieChart isLoading={loading}>
                <Message title={'Column not in the correct format to display on Pie Chart'} copy={''} type={'info'} />
            </StyledPieChart>
        );
    }
    return (
        <StyledPieChart isLoading={loading}>
            <CommonHighcharts
                highcharts={Highcharts}
                options={{ ...config.chart.options }}
                containerProps={{
                    style: {
                        height: '100 %',
                    },
                }}
            />
        </StyledPieChart>
    );
};

export default PieChart;
